import type { z } from 'zod'
import { FieldRegistryEntry, fieldRegistry } from './registry'
import type { FormLayoutField } from './types'

/**
 * Maps a Zod schema to layout fields to be used in building layouts
 * @param fields
 * @returns
 */
export const allFieldsToFormLayoutFields = <T extends z.ZodObject>(
  fields: T,
): { [K in keyof T['shape']]: FormLayoutField } => {
  return Object.fromEntries(
    Object.entries(fields.shape).map(
      ([key, value]: [keyof T['shape'], z.ZodType]) => {
        const metadata = fieldRegistry.get(value)

        if (!metadata) {
          throw new Error(`Field metadata not found for key: ${String(key)}`)
        }

        const parsedMetadata = FieldRegistryEntry.parse(metadata)

        const field: FormLayoutField = {
          key: String(key),
          label: parsedMetadata.label,
          fieldType: metadata.fieldType,
          placeholder: parsedMetadata.placeholder,
          required: parsedMetadata.required,
          options:
            'options' in parsedMetadata ? parsedMetadata.options : undefined,
          type: 'field',
          tooltip: parsedMetadata.tooltip,
          maxPhotos: parsedMetadata.maxPhotos,
        }

        return [key, field]
      },
    ),
    // TODO: inspect if this type cast is correct
  ) as { [K in keyof T['shape']]: FormLayoutField }
}
